import React from "react";

// Mui Styles
// import { styled } from "@mui/material/styles";
import { StyledPaper } from "@/styles/mui/globalStyles";
import { TableListTheme } from "@/styles/mui/tableListTheme";
import DownloadIcon from "@mui/icons-material/Download";
import SearchIcon from "@mui/icons-material/Search";
import Checkbox from "@mui/material/Checkbox";
import { ThemeProvider, createTheme } from "@mui/material/styles";

// Mui
import GiveawayFooter from "@/components/DataTable/giveawayFooter";
import DateSelection from "@/components/dateSelection";
import { giveawayInvoiceColumn } from "@/config/tableColumnConfig";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid2";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import { useGridApiRef } from "@mui/x-data-grid";

// Navigate
import { useLocation, useNavigate } from "react-router-dom";
// Components
import DataTable from "@/components/dataTable";
import GiveawayDetailDialog from "@/components/Dialog/giveawayDetailDialog";
import ProductAutoComplete from "@/components/Filter/productAutocomplete";
import Layout from "@/components/layout";
import Title from "@/components/title";
import { useSelector } from "react-redux";
// Moment
import moment from "moment";
import "moment/locale/zh-hk";

// Zoom Images
// import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";

// Fetch
import {
  checkGiveawayInvoice,
  exportExcel,
  getGiveawayInvoice,
  getGiveawayInvoiceById,
  getProducts as getGiveways,
} from "@/fetch/fetchGiveaway";

import { getAllPromoter } from "@/fetch/fetchStaff";
import { getProducts } from "@/fetch/fetchStatistics";

import { useCurrentAction } from "@/hooks/user";

import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";

const CustomerDailyPage = (props) => {
  const { open, setOpen } = props;
  const actions = useCurrentAction();
  const apiRef = useGridApiRef();

  // Navigate
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;

  const [promotorData, setPromotorData] = React.useState([]);
  const [productData, setProductData] = React.useState([]);
  const [giveawayData, setGiveawayData] = React.useState([]);
  const [expanded, setExpanded] = React.useState(true);

  const [selectedPromotorId, setSelectedPromotorId] = React.useState([]);
  const [phone, setPhone] = React.useState("");
  const [isExporting, setIsExporting] = React.useState(false);

  const [dataTableLoading, setDataTableLoading] = React.useState(false);
  const defaultStartDate = moment().subtract(1, "day").format("YYYY-MM-DD");
  const defaultEndDate = moment().format("YYYY-MM-DD");
  const [selectedProduct, setSelectedProduct] = React.useState([]);
  const [selectedGiveaway, setSelectedGiveaway] = React.useState([]);

  const [invoicesData, setInvoicesData] = React.useState([]);
  const [invoiceData, setInvoiceData] = React.useState({
    purchase: [],
    giveaway: [],
  });
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const startDate = useSelector(
    (state) =>
      state.system.selectedDate[pathname]?.startDate ?? defaultStartDate,
  );
  const endDate = useSelector(
    (state) => state.system.selectedDate[pathname]?.endDate ?? defaultEndDate,
  );

  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;

  // Theme
  const theme = createTheme({
    components: {
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            borderRadius: 16,
          },
        },
      },
    },
  });

  const handleCheckClick = async (d) => {
    try {
      await checkGiveawayInvoice(d.id);
      await onCellClick(d);
      apiRef.current.updateRows([{ invoice_id: d.id, is_checked: true }]);
    } catch (err) {}
  };

  const handleOnChangePromotor = (promotors) => {
    const promotorId =
      promotors.length > 0 ? promotors.map((promotor) => promotor.id) : [];
    setSelectedPromotorId(promotorId);
  };

  // Fetch
  const fetchAll = async () => {
    try {
      // const { data: workLocationData } = await getAllWorkLocation(true);
      const { data: promotorData } = await getAllPromoter(true);
      const sortedPromotor = promotorData.sort((a, b) =>
        ("" + a.alias).localeCompare(b.alias),
      );
      const { data: productData } = await getProducts();
      const { data: giveawayData } = await getGiveways();
      setPromotorData(sortedPromotor);
      setProductData(productData);
      setGiveawayData(giveawayData);
      await fetchCustomerDaily();
    } catch (err) {
      console.log(err);
    }
  };

  const fetchCustomerDaily = async () => {
    setDataTableLoading(true);
    const { data: invoices } = await getGiveawayInvoice(
      selectedPromotorId,
      startDate,
      endDate,
      selectedProduct,
      selectedGiveaway,
      phone,
    );
    setInvoicesData(invoices);
    setDataTableLoading(false);
    setExpanded(false);
  };

  const handleSearch = async () => {
    fetchCustomerDaily();
  };

  const filterOptions = createFilterOptions({
    matchFrom: "any",
    ignoreCase: true,
    stringify: (option) => `${option.alias} ${option.staff_code}`,
  });
  const onCellClick = async (d) => {
    const { data: invoice } = await getGiveawayInvoiceById(d.id);
    setInvoiceData(invoice);
    setDialogOpen(true);
  };
  React.useEffect(() => {
    fetchAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  moment.updateLocale("zh-hk", {
    weekdaysShort: ["日", "一", "二", "三", "四", "五", "六"],
  });
  const handleexportExcel = async () => {
    try {
      setIsExporting(true);
      await exportExcel(
        selectedPromotorId,
        startDate,
        endDate,
        selectedProduct,
        selectedGiveaway,
        phone,
      ).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `Giveaway List (${startDate}-${endDate}).xlsx`,
        );
        document.body.appendChild(link);
        link.click();
      });
    } catch (error) {
    } finally {
      setIsExporting(false);
    }
  };
  return (
    <Layout
      header="CustomerDailyPage"
      selectedIndex={11}
      open={open}
      setOpen={setOpen}
    >
      <Title
        title={`登記清單`}
        history={() => navigate(-1)}
        children={
          actions?.download ? (
            <IconButton
              component="label"
              onClick={() => handleexportExcel()}
              loading={isExporting}
            >
              <DownloadIcon />
            </IconButton>
          ) : null
        }
      />
      <ThemeProvider theme={theme}>
        <Accordion
          expanded={expanded}
          style={{ flexGrow: 1, display: "block" }}
        >
          <AccordionSummary
            expandIcon={
              <ExpandMoreIcon
                onClick={() => setExpanded(!expanded)}
              ></ExpandMoreIcon>
            }
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <SearchIcon></SearchIcon>
          </AccordionSummary>
          <AccordionDetails>
            <Stack
              width={"100%"}
              direction={"row"}
              justifyContent={"space-between"}
              alignItems={"center"}
              sx={{ flexWrap: "wrap" }}
            >
              <Box width={"80%"}>
                <Grid container spacing={2}>
                  <Grid container spacing={2} size={12}>
                    <DateSelection
                      defaultStartDate={defaultStartDate}
                      defaultEndDate={defaultEndDate}
                      xs={12}
                      md={6}
                      lg={6}
                    ></DateSelection>
                  </Grid>
                  <Grid container spacing={2} size={12}>
                    <Grid size={4}>
                      <TextField
                        fullWidth
                        value={phone}
                        label="客人電話"
                        variant="outlined"
                        onChange={(event) => setPhone(event.target.value)}
                      />
                    </Grid>
                    <Grid size={4}>
                      <Autocomplete
                        filterOptions={filterOptions}
                        disableCloseOnSelect
                        multiple
                        fullWidth
                        options={promotorData}
                        autoComplete
                        id="work-select"
                        name="work"
                        isOptionEqualToValue={(option, value) =>
                          option.id === value.id
                        }
                        onChange={(event, data) => {
                          handleOnChangePromotor(data);
                        }}
                        getOptionLabel={(option) => `${option.alias}`}
                        renderOption={(props, option, { selected }) => {
                          const { key, ...rest } = props;
                          return (
                            <Box key={key} component="li" {...rest}>
                              <Checkbox
                                icon={icon}
                                checkedIcon={checkedIcon}
                                style={{ marginRight: 8 }}
                                checked={selected}
                              />
                              {option.alias} ({option.staff_code}){" "}
                              {option.is_delete ? "- 已離職" : ""}
                            </Box>
                          );
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="選擇員工"
                            sx={{ width: "100%" }}
                          />
                        )}
                      />
                    </Grid>
                    <Grid size={4}>
                      <ProductAutoComplete
                        label={"選擇換領贈品"}
                        multiple
                        fullWidth={true}
                        productOptions={giveawayData}
                        handleOnChange={(data) => {
                          const newValue = data.includes("ALL")
                            ? data.length > giveawayData.length
                              ? []
                              : giveawayData.map((item) => item.id)
                            : data;
                          setSelectedGiveaway(newValue);
                        }}
                        selectedValue={selectedGiveaway}
                      ></ProductAutoComplete>
                    </Grid>
                  </Grid>
                </Grid>
              </Box>
              <Box
                width="20%"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Button
                  variant="contained"
                  onClick={handleSearch}
                  endIcon={<SearchIcon />}
                >
                  搜尋
                </Button>
              </Box>
            </Stack>
          </AccordionDetails>
        </Accordion>
      </ThemeProvider>
      <StyledPaper page={"yes"} style={{ overflowX: "auto" }}>
        <ThemeProvider theme={TableListTheme}>
          <DataTable
            rows={invoicesData}
            columns={giveawayInvoiceColumn}
            pageSize={100}
            getRowId={(row) => row.invoice_id}
            loading={dataTableLoading}
            onCellClick={onCellClick}
            apiRef={apiRef}
            Footer={GiveawayFooter}
          />
          <GiveawayDetailDialog
            open={dialogOpen}
            handleCheckClick={handleCheckClick}
            data={invoiceData}
            onCancel={() => setDialogOpen(false)}
          ></GiveawayDetailDialog>
        </ThemeProvider>
      </StyledPaper>
    </Layout>
  );
};

export default CustomerDailyPage;
